var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20p"},[_c('vl-textarea',{attrs:{"label":"Wens je opmerkingen toe te voegen?","placeholder":"Schrijf een opmerking…"},model:{value:(_vm.Model),callback:function ($$v) {_vm.Model=$$v},expression:"Model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }